const l = ({ type: e, $size: a = "small" }) => {
  const t = a === "medium" ? "9px" : "4px";
  return e === "color" ? `${t}` : `${t} 12px`;
};
export {
  l as default
};
